/** Narrows an `unknown` value, such as parsed JSON, to an indexable object. */
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}
